<script>
  import Page from 'page'
  import { api } from '../../store'
  let localapi
  api.subscribe((value) => {
    localapi = value
  })
  let IndianStates = [
    'Andhra Pradesh',
    'Arunachal Pradesh',
    'Assam',
    'Bihar',
    'Chhattisgarh',
    'Goa',
    'Gujarat',
    'Haryana',
    'Himachal Pradesh',
    'Jharkhand',
    'Karnataka',
    'Kerala',
    'Madhya Pradesh',
    'Maharashtra',
    'Manipur',
    'Meghalaya',
    'Mizoram',
    'Nagaland',
    'Odisha',
    'Punjab',
    'Rajasthan',
    'Sikkim',
    'Tamil Nadu',
    'Telangana',
    'Tripura',
    'Uttar Pradesh',
    'Uttarakhand',
    'West Bengal',
  ]

  let USStates = [
    'Alabama',
    'Alaska',
    'Arizona',
    'Arkansas',
    'California',
    'Colorado',
    'Connecticut',
    'Delaware',
    'Florida',
    'Georgia',
    'Hawaii',
    'Idaho',
    'Illinois',
    'Indiana',
    'Iowa',
    'Kansas',
    'Kentucky',
    'Louisiana',
    'Maine',
    'Maryland',
    'Massachusetts',
    'Michigan',
    'Minnesota',
    'Mississippi',
    'Missouri',
    'Montana',
    'Nebraska',
    'Nevada',
    'New Hampshire',
    'New Jersey',
    'New Mexico',
    'New York',
    'North Carolina',
    'North Dakota',
    'Ohio',
    'Oklahoma',
    'Oregon',
    'Pennsylvania',
    'Rhode Island',
    'South Carolina',
    'South Dakota',
    'Tennessee',
    'Texas',
    'Utah',
    'Vermont',
    'Virginia',
    'Washington',
    'West Virginia',
    'Wisconsin',
    'Wyoming',
  ]

  let firstName,
    lastName,
    address,
    zipcode,
    state,
    city,
    mobileNumber,
    email,
    profession,
    division,
    subDivision,
    speciality,
    indianState,
    icity
  let password = 'password'

  function validateForm() {
    let allValue = {
      type: 'member',
      firstName,
      lastName,
      address,
      zipcode,
      state,
      city,
      mobileNumber,
      email,
      password,
      profession,
      division,
      subDivision,
      speciality,
      indianState,
      icity,
    }

    let error = ''

    for (const [key, value] of Object.entries(allValue)) {
      if (value === undefined) {
        error += `${key}\n`
        console.log(key)
      }
    }

    error == ''
      ? senddata(allValue)
      : alert(`Please fill the folowing fields \n${error}`)
  }

  let senddata = async (param) => {
    let loginDatum = JSON.parse(localStorage.getItem('loginData'))
    let mainid = JSON.parse(localStorage.getItem('loginData')).email
    let data = new FormData()
    data.append('firstName', param.firstName)
    data.append('lastName', param.lastName)
    data.append('address', param.address)
    data.append('zipcode', param.zipcode)
    data.append('state', param.state)
    data.append('city', param.city)
    data.append('mobileNumber', param.mobileNumber)
    data.append('email', param.email)
    data.append('password', param.password)
    data.append('profession', param.profession)
    data.append('division', param.division)
    data.append('subDivision', param.subDivision)
    data.append('speciality', param.speciality)
    data.append('indianState', param.indianState)
    data.append('icity', param.icity)
    data.append('mainid', mainid)

    let xhttp = new XMLHttpRequest()

    // xhttp.setRequestHeader('Content-type', 'application/x-www-form-urlencoded')
    xhttp.onreadystatechange = function () {
      if (this.readyState == 4 && this.status == 200) {
        // Typical action to be performed when the document is ready:
        let result = JSON.parse(xhttp.responseText)
        console.log(result)

        if (result.error == false) {
          window.location.reload()
        } else {
          Page.redirect('/logout')
        }
      }
    }
    xhttp.open('POST', `${localapi}?url=createMemberSpouse`, true)
    xhttp.setRequestHeader('Authorization', `Bearer ${loginDatum.token}`)
    xhttp.send(data)
  }
</script>

<div class="login">
  <form on:submit|preventDefault="{validateForm}">
    <div>
      <h2 class="text-center">Add Spouse</h2>
    </div>

    <div class="row">
      <div class="form-group  col-6 mb-3 mt-3">
        <label for="exampleInputEmail1">First Name</label>
        <input
          required
          type="text"
          class="form-control"
          bind:value="{firstName}" />
      </div>

      <div class="form-group  col-6 mb-3 mt-3">
        <label for="exampleInputEmail1">Last Name</label>
        <input
          required
          type="text"
          class="form-control"
          bind:value="{lastName}" />
      </div>

      <div class="form-group col-12 mb-3 mt-3">
        <label for="exampleInputEmail1">Address</label>
        <input
          required
          type="text"
          class="form-control"
          bind:value="{address}" />
      </div>

      <div class="form-group col-12 mb-3 mt-3">
        <label for="exampleInputEmail1">City</label>
        <input required type="text" class="form-control" bind:value="{city}" />
      </div>

      <div class="form-group col-12 mb-3 mt-3">
        <label for="exampleInputEmail1">Zip Code</label>
        <input
          required
          type="text"
          class="form-control"
          bind:value="{zipcode}" />
      </div>

      <div class="input-group col-12 row mb-3 mt-3">
        <div class="input-group-prepend col-4">
          <label class="input-group-text" for="inputGroupSelect01">
            State
          </label>
        </div>
        <select
          required
          class="custom-select col-8"
          id="inputGroupSelect01"
          bind:value="{state}">
          {#each USStates as state}
            <option value="{state}">{state}</option>
          {/each}
        </select>
      </div>

      <div class="form-group  col-6 mb-3 mt-3">
        <label for="exampleInputEmail1">Email</label>
        <input
          required
          type="email"
          class="form-control"
          bind:value="{email}" />
      </div>

      <div class="form-group  col-6 mb-3 mt-3">
        <label for="exampleInputEmail1">Mobile Number</label>
        <input
          required
          type="text"
          class="form-control"
          bind:value="{mobileNumber}" />
      </div>

      <div class="form-group d-none col-6 mb-3 mt-3">
        <label for="exampleInputEmail1">Password</label>
        <input
          required
          type="text"
          class="form-control"
          bind:value="{password}" />
      </div>

      <div class="form-group col-6 mb-3 mt-3">
        <label for="exampleInputEmail1">Division (kulam)</label>
        <input
          required
          type="text"
          class="form-control"
          list="kulam"
          bind:value="{division}" />
        <datalist id="kulam">
          <option value="Allikondaar"> </option><option value="Aalkoozhnaeru">
          </option><option value="Allkulanelaru"> </option><option
            value="Ambukolnaeru">
          </option><option value="Ambugulnar"> </option><option
            value="Annelaar">
          </option><option value="Appukoldhaar"> </option><option
            value="Aranganathar">
          </option><option value="Baanilaar"> </option><option
            value="Baalelaar">
          </option><option value="Baalilaar"> </option><option
            value="Baaniyaar">
          </option><option value="Bakthimallanaar"> </option><option
            value="Balithaar">
          </option><option value="Bojjelaar"> </option><option
            value="Chinnukotlaar">
          </option><option value="Enthelaar"> </option><option
            value="Gudigelaar">
          </option><option value="Irumaner"> </option><option value="Kadubelar">
          </option><option value="Kallukotlaar"> </option><option
            value="Kappelaar">
          </option><option value="Kanjalakutlaar"> </option><option
            value="Kenjalakudithaar">
          </option><option value="Kenjalukuthidaar"> </option><option
            value="Koradhaar">
          </option><option value="Laddhekaar"> </option><option value="Malaler">
          </option><option value="Maalidhaar"> </option><option
            value="Maralelaar">
          </option><option value="Malyathavar"> </option><option
            value="Minjilar">
          </option><option value="Muchaladhaar"> </option><option
            value="Muthaladavaru">
          </option><option value="Muthaledar"> </option><option
            value="Muthundhar">
          </option><option value="Pannethar"> </option><option
            value="Pavalathar">
          </option><option value="Pawthamalner"> </option><option
            value="Pojaler">
          </option><option value="Sevvelar"> </option><option
            value="Sidhukoludhaar">
          </option><option value="Thubbaelaar"> </option><option
            value="Thubbelar">
          </option></datalist>
      </div>

      <div class="form-group col-6 mb-3 mt-3">
        <label for="exampleInputEmail1">Sub-Division (Gotram)</label>
        <input
          required
          type="text"
          class="form-control"
          list="gotram"
          bind:value="{subDivision}" />
        <datalist id="gotram">
          <option value="Aananda Bairavi Mahirishi"> </option><option
            value="Aashritha Maharishi">
          </option><option value="Aasuvalaayana Maharishi"> </option><option
            value="Aathreya Maharishi">
          </option><option value="Acchudha Maharishi"> </option><option
            value="Aditha Maharishi">
          </option><option value="Agarcha Maharishi"> </option><option
            value="Agastya Maharishi">
          </option><option value="Amara Maharishi"> </option><option
            value="Anjana Devarishi">
          </option><option value="Aritsha Maharishi"> </option><option
            value="Ashra Maharishi">
          </option><option value="Asideva Maharishi"> </option><option
            value="Atchaya Devarishi">
          </option><option value="Athiri Maharishi"> </option><option
            value="Athivi Maharishi">
          </option><option value="Baaga Maharishi"> </option><option
            value="Baavaja Maharishi">
          </option><option value="Babaala Maharishi"> </option><option
            value="Bagadeva Maharishi">
          </option><option value="Bagathaalpiya Maharishi"> </option><option
            value="Bharadhwaja Maharishi">
          </option><option value="Bhaskara Maharishi"> </option><option
            value="Bheemaga Maharishi">
          </option><option value="Bibbaala Maharishi"> </option><option
            value="Boga Maharishi">
          </option><option value="Bowlashya Maharishi"> </option><option
            value="Brammaanda Maharishi">
          </option><option value="Brugu Maharishi"> </option><option
            value="Brundha Maharishi">
          </option><option value="Brungi Maharishi"> </option><option
            value="Chandirakula Maharishi">
          </option><option value="Chitravargha Maharishi"> </option><option
            value="Dadeesi Maharishi">
          </option><option value="Daseetha Maharishi"> </option><option
            value="Deva Maharishi">
          </option><option value="Devadatta Maharishi"> </option><option
            value="Devala Maharishi">
          </option><option value="Devaraatha Maharishi"> </option><option
            value="Dhaivakya Maharishi">
          </option><option value="Dhaivaraatha Maharishi"> </option><option
            value="Dhurvaasa Maharishi">
          </option><option value="Dowbaaya Maharishi"> </option><option
            value="Durmabindhu Maharishi">
          </option><option value="Gouthama Maharishi"> </option><option
            value="Gouthsya Maharishi">
          </option><option value="Haala Hala Maharishi"> </option><option
            value="Haritha Maharishi">
          </option><option value="Indirathooimam Deva Maharishi">
          </option><option value="Jaabaali Maharishi"> </option><option
            value="Jaalaga Maharishi">
          </option><option value="Jaantha Maharishi"> </option><option
            value="Jamadhagni Maharishi">
          </option><option value="Jambaari Maharishi"> </option><option
            value="Jambu Maharishi">
          </option><option value="Jamu Maharishi"> </option><option
            value="Janaga Maharishi">
          </option><option value="Jayamuni Maharishi"> </option><option
            value="Kaabaala Maharishi">
          </option><option value="Kaalava Maharishi"> </option><option
            value="Kaamuga Maharishi">
          </option><option value="Kaana Maharishi"> </option><option
            value="Kaangeya Maharishi">
          </option><option value="Kaarkeya Maharishi"> </option><option
            value="Kaasiyaba Maharishi">
          </option><option value="Kaathya Maharishi"> </option><option
            value="Kaathya Kaathyaayana Deva Maharishi">
          </option><option value="Kabila Maharishi"> </option><option
            value="Kanaga Maharishi">
          </option><option value="Kanva Maharishi"> </option><option
            value="Karasaka Maharishi">
          </option><option value="Karthikeya Maharishi"> </option><option
            value="Kavusa Maharishi">
          </option><option value="Kindhama Maharishi"> </option><option
            value="Kirudhu Maharishi">
          </option><option value="Kowndalya Maharishi"> </option><option
            value="Kowshika Maharishi">
          </option><option value="Krounja Maharishi"> </option><option
            value="Krounjalya Maharishi">
          </option><option value="Ksema Ksemandha Ksemandra Maharishi">
          </option><option value="Kudumba Maharishi"> </option><option
            value="Kumba Sambava Maharishi">
          </option><option value="Kusha Maharishi"> </option><option
            value="Kuthaala Maharishi">
          </option><option value="Kuthsaga Maharishi"> </option><option
            value="Maalka Maharishi">
          </option><option value="Maandavya Maharishi"> </option><option
            value="Maanya Maharishi">
          </option><option value="Maarkandeya Maharishi"> </option><option
            value="Maithrathuima Maharishi">
          </option><option value="Maithreya Maharishi"> </option><option
            value="Mallaa Deva Maharishi">
          </option><option value="Mandira Deva Maharishi"> </option><option
            value="Manjula Maharishi">
          </option><option value="Manmadha Maharishi"> </option><option
            value="Manorama Maharishi">
          </option><option value="Manu Maharishi"> </option><option
            value="Manuvaama Maharishi">
          </option><option value="Mareesi Maharishi"> </option><option
            value="Mathanga Maharishi">
          </option><option value="Mathsaya Maharishi"> </option><option
            value="Mrukandu Maharishi">
          </option><option value="Mruthyunjaya Maharishi"> </option><option
            value="Muga Maharishi">
          </option><option value="Muthkala Maharishi"> </option><option
            value="Muthu Maharishi">
          </option><option value="Muvvala Maharishi"> </option><option
            value="Naagaradeva Maharishi">
          </option><option value="Naamadeva Maharishi"> </option><option
            value="Naaratha Maharishi">
          </option><option value="Naikkiyadeva Maharishi"> </option><option
            value="Padma Maharishi">
          </option><option value="Paraasara Maharishi"> </option><option
            value="Parvatha Maharishi">
          </option><option value="Pathanjali Maharishi"> </option><option
            value="Pigi Maharishi">
          </option><option value="Pirugu Maharishi"> </option><option
            value="Pirungadeva Maharishi">
          </option><option value="Pirungi Maharishi"> </option><option
            value="Prathaapa Maharishi">
          </option><option value="Pulasthiya Maharishi"> </option><option
            value="Punardeva Maharishi">
          </option><option value="Pundareega Maharishi"> </option><option
            value="Puratcha Maharishi">
          </option><option value="Purukootha Maharishi"> </option><option
            value="Pusha Maharishi">
          </option><option value="Raaja Maharishi"> </option><option
            value="Raajakulatamahadeva Maharishi">
          </option><option value="Ragasya Maharishi"> </option><option
            value="Raippiya Maharishi">
          </option><option value="Rippilaaya Maharishi"> </option><option
            value="Rishya Maharishi">
          </option><option value="Rukdeva Maharishi"> </option><option
            value="Rushya Maharishi">
          </option><option value="Ruthvija Maharishi"> </option><option
            value="Saalihotra Maharishi">
          </option><option value="Saanaka Maharishi"> </option><option
            value="Saandilya Maharishi">
          </option><option value="Saangiya Maharishi"> </option><option
            value="Saangiyaayana Maharishi">
          </option><option value="Saanthirayana Maharishi"> </option><option
            value="Saararatha Maharishi">
          </option><option value="Saarathvandhu Maharishi"> </option><option
            value="Sachithaanandha Maharishi">
          </option><option value="Sadhanandha Maharishi"> </option><option
            value="Sadhumuga Maharishi">
          </option><option value="Saguni Maharishi"> </option><option
            value="Sambu Maharishi">
          </option><option value="Sanadhana Deva Maharishi"> </option><option
            value="Sanaga Sanandha Maharishi">
          </option><option value="Sanathkumara Maharishi"> </option><option
            value="Sanathujatha Maharishi">
          </option><option value="Sandhana Maharishi"> </option><option
            value="Sangalya Maharishi">
          </option><option value="Sangu Maharishi"> </option><option
            value="Sankarshana Maharishi">
          </option><option value="Sarasadampa Maharishi"> </option><option
            value="Sarasujaatha Maharishi">
          </option><option value="Sarva Maharishi"> </option><option
            value="Savithira Maharishi">
          </option><option value="Sirukka Maharishi"> </option><option
            value="Sirungi Maharishi">
          </option><option value="Siva Sivagnana Maharishi"> </option><option
            value="Somagalya Maharishi">
          </option><option value="Somaka Maharishi"> </option><option
            value="Somakalya Maharishi">
          </option><option value="Somakula Maharishi"> </option><option
            value="Somendra Maharishi">
          </option><option value="Somothbava Maharishi"> </option><option
            value="Soorasowva Maharishi">
          </option><option value="Sowkiya Maharishi"> </option><option
            value="Sowlapya Maharishi">
          </option><option value="Sowlasthiya Maharishi"> </option><option
            value="Sownaga Maharishi">
          </option><option value="Suga Maharishi"> </option><option
            value="Sugothbava Maharishi">
          </option><option value="Sukreeva Maharishi"> </option><option
            value="Suryakula Maharishi">
          </option><option value="Suthmala Maharishi"> </option><option
            value="Suyambudeva Saatvikadeva Maharishi">
          </option><option value="Swayumbuva Maharishi"> </option><option
            value="Syaalaga Maharishi">
          </option><option value="Thaalcha Maharishi"> </option><option
            value="Thaalpiya Maharishi">
          </option><option value="Thalappiyadeva Maharishi"> </option><option
            value="Thamba Maharishi">
          </option><option value="Thamravarna Maharishi"> </option><option
            value="Thatha Maharishi">
          </option><option value="Thirunabindhu Maharishi"> </option><option
            value="Thrayambaga Maharishi">
          </option><option value="Thuthsa Maharishi"> </option><option
            value="Thuvaipaayana Maharishi">
          </option><option value="Thuvanthadeva Maharishi"> </option><option
            value="Ubamanyu Maharishi">
          </option><option value="Ushana Maharishi"> </option><option
            value="Vaalakilya Maharishi">
          </option><option value="Vaamadeva Maharishi"> </option><option
            value="Vaaru Maharishi">
          </option><option value="Vaaruna Maharishi"> </option><option
            value="Valmiki Maharishi">
          </option><option value="Vanjula Maharishi"> </option><option
            value="Varathantha Maharishi">
          </option><option value="Vashishta Maharishi"> </option><option
            value="Vasudeva Maharishi">
          </option><option value="Vatsa Maharishi"> </option><option
            value="Vebana Maharishi">
          </option><option value="Veda Maharishi"> </option><option
            value="Veerathanthi Maharishi">
          </option><option value="Vidya Maharishi"> </option><option
            value="Vikgnana Maharishi">
          </option><option value="Vishwamithra Maharishi"> </option><option
            value="Vyaakrapaatha Maharishi">
          </option><option value="Vyasa Maharishi"> </option><option
            value="Yaakgnya Deva Maharishi">
          </option><option value="Yaaknjyavalkiya Maharishi"> </option><option
            value="Yogabrindha Maharishi">
          </option></datalist>
      </div>

      <div class="form-group  col-6 mb-3 mt-3">
        <label for="exampleInputEmail1">Profession</label>
        <input
          required
          type="text"
          class="form-control"
          bind:value="{profession}" />
      </div>

      <div class="form-group col-6 mb-3 mt-3">
        <label for="exampleInputEmail1">Speciality</label>
        <input
          required
          type="text"
          class="form-control"
          bind:value="{speciality}" />
      </div>

      <div class="input-group col-12 row mb-3 mt-3">
        <div class="input-group-prepend col-5">
          <label class="input-group-text" for="inputGroupSelect01">
            Indian State
          </label>
        </div>
        <select
          required
          class="custom-select col-7"
          id="inputGroupSelect01"
          bind:value="{indianState}">
          {#each IndianStates as state}
            <option value="{state}">{state}</option>
          {/each}
        </select>
      </div>
    </div>

    <div class="form-group col-6 mb-3 mt-3">
      <label for="exampleInputEmail1">Native City</label>
      <input required type="text" class="form-control" bind:value="{icity}" />
    </div>

    <button type="submit" class="btn btn-primary">Submit</button>
  </form>
</div>

<style lang="scss">
  .login {
    padding: 10px;
    min-height: 80vh;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 2vh;
    margin-bottom: 10vh;
    background-color: #fff;

    form {
      width: 100%;
      max-width: 500px;
    }
  }
</style>
